








import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
@Component({})
export default class GicarAuthCallback extends mixins() {
  loading = true;
  error = "";
  mounted() {
    console.log("TTT GicarAuthCallback handleCallback mounted");
    this.handleCallback();
  }
  async handleCallback() {
    const urlParams = new URLSearchParams(window.location.search);
    console.log("TTT GicarAuthCallback handleCallback urlParams ", urlParams)
    const code = urlParams.get("code");
    const state = urlParams.get("state");
    const storedState = localStorage.getItem("oauthState");

    // Validación de estado (prevención de CSRF)
    if (!state || state !== storedState) {
      this.error = "Error: Estado inválido. Posible ataque CSRF.";
      this.loading = false;
      return;
    }

    console.log("TTT GicarAuthCallback handleCallback code ", code);

    /*try {
      // Intercambiar el code por los tokens
      const response = await this.exchangeCodeForTokens(code);

      if (!response.ok) {
        throw new Error("Error al intercambiar el código por tokens");
      }

      const data = await response.json();
      const { id_token, access_token } = data;

      // Validación de nonce (prevención de ataques de repetición)
      const decodedToken = JSON.parse(atob(id_token.split('.')[1])); // Decodificar JWT
      const storedNonce = localStorage.getItem("oauthNonce");

      if (decodedToken.nonce !== storedNonce) {
        throw new Error("Error: nonce inválido. Posible ataque de repetición.");
      }

      // Almacenar tokens en localStorage
      localStorage.setItem("access_token", access_token);
      localStorage.setItem("id_token", id_token);

      this.loading = false;
      // Redirigir o actualizar el estado según sea necesario
      this.$router.push("/"); // O cualquier ruta que quieras redirigir
    } catch (error) {
      this.error = `Error: ${error.message}`;
      this.loading = false;
    }*/
  }
  async exchangeCodeForTokens(code: string | null) {
    const clientId = "tu-client-id";
    const clientSecret = "tu-client-secret";
    const redirectUri = "https://tu-aplicacion.com/callback";

    const body = new URLSearchParams({
      client_id: clientId,
      client_secret: clientSecret,
      grant_type: "authorization_code",
      code: code || "",
      redirect_uri: redirectUri,
    });

    return await fetch("https://gicar-ad/protocol/openid-connect/token", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body,
    });
  }
}
